// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner_loadingSpinner__d2uHj","loadingOverlay":"LoadingSpinner_loadingOverlay__24-BT"};